import React from 'react';
import { useLanguage } from '../../../../context/LanguageContext';
import '../../../../assets/css/style.css';
import '../style/whatsapp-button.css';
import { trackWhatsAppClick } from '../../email/utils/trackingUtils';

const WhatsAppButton: React.FC = () => {
    const { t } = useLanguage();

    return (
        <a 
            href="https://wa.me/351963669277" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatsapp-button-custom" 
            aria-label={t.BUTTONS.whatsappButtonTooltip}
         onClick={() => trackWhatsAppClick('floating_button')}>
            <div className="whatsapp-button-custom__wrapper">
                <div className="whatsapp-button-custom__circle">
                    <i className="fab fa-whatsapp whatsapp-button-custom__icon"></i>
                    <div className="whatsapp-button-custom__badge">
                        <i className="fas fa-comment-dots whatsapp-button-custom__badge-icon"></i>
                    </div>
                </div>
                <div className="whatsapp-button-custom__tooltip">
                    <span>{t.BUTTONS.whatsappButtonTooltip}</span>
                </div>
            </div>
        </a>
    );
};

export default WhatsAppButton;

